import { SelectAsyncInput } from '@core/components/Select';
import codigoTributacaoNacionalApi from 'app/services/api/servicoFiscal/codigoTributacaoNacionalApi';
import React from 'react';

const SelectCtn = ({ id, name, label, value, touched, error, onBlur, onChange, disabled, required = false }) => {
  return (
    <SelectAsyncInput
      id={id}
      name={name}
      label={label}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      error={error}
      touched={touched}
      disabled={disabled}
      required={required}
      getOptionKey={(option) => {
        return option?.id;
      }}
      getOptionLabel={(option) => {
        return option?.codigo && option?.descricao ? `${option.codigo} - ${option.descricao}` : '';
      }}
      fetchOnFocus
      fetchData={async (query = '', next = 0) => {
        if (typeof query === 'object') {
          query = '';
        }

        let response = null;

        response = await codigoTributacaoNacionalApi.pesquisarCodigoTributacaoNacional({
          size: 500,
          sort: 'codigo',
          page: next,
          q: query,
        });

        const data = response?.data || [];

        console.log('data: ', data);

        return { data };
      }}
    />
  );
};

export default SelectCtn;
